/**
 * flashUserContext.ts
 * Lets a deeply-nested assignee row (in any of the three Phase-2 task views) trigger the
 * "flash this person in the capacity grid" locator without threading a callback through
 * every grid + cell. Phase2Panel provides the implementation (useFlashUserRow bound to the
 * rail container); the assignee name/avatar calls useFlashUser() on click (2026-06-25).
 */
import { createContext, useContext } from 'react';

/** Flash the given user's row in the Employee Weekly Capacity grid. No-op by default. */
export const FlashUserContext = createContext<(userKey: string) => void>(() => {});

export function useFlashUser(): (userKey: string) => void {
  return useContext(FlashUserContext);
}
